import React from "react";
import CompanyNameHeader from "../Shared/CompanyName/CompanyName";
import ExecutiveSummary from "./Assets/ExcecutiveSummary";
import CompanyInsights from "./Assets/CompanyInsights";
import MarketOverview from "./Assets/MarketOverview";

// 1. Company Overview constants
const companyDetails = {
  name: "GoFood LLC",
  location: "Boston, MA, United States",
  industry: "Food & Beverage (Mobile Food Services)",
  founded: 2017,
  valuationDate: "February 2025",
};

const CompanyOverview = () => {
  return (
    <div>
      {/* 0. company name */}
      <CompanyNameHeader />

      {/* 1. Company Overview */}
      <div className="bg-white p-6 shadow rounded-lg mb-6">
        <h2 className="text-lg font-medium text-gray-900 mb-2">Company Overview</h2>
        <p className="mt-2 text-gray-700"><strong>🏢 Company Name:</strong> {companyDetails.name}</p>
        <p className="mt-2 text-gray-700"><strong>📍 Location:</strong> {companyDetails.location}</p>
        <p className="mt-2 text-gray-700"><strong>🏧 Industry:</strong> {companyDetails.industry}</p>
        <p className="mt-2 text-gray-700"><strong>🗓 Founded:</strong> {companyDetails.founded}</p>
        <p className="mt-2 text-gray-700"><strong>📆 Valuation Date:</strong> {companyDetails.valuationDate}</p>
      </div>

      {/* 1.1 Company Insights */}
      <CompanyInsights />

      {/* 1.2 Executive Summary */}
      <ExecutiveSummary />

      {/* 1.3 Market Overview */}
      <MarketOverview />
    </div>

  );
};

export default CompanyOverview;
